import { Link } from 'react-router-dom';
import { useSEO } from '../hooks/useSEO';
import styles from './BlogIndex.module.css';
import { SectionWrapper } from '../components/shared/SectionWrapper';
import { Chip } from '../components/shared/Chip';
import { ScriptText } from '../components/shared/ScriptText';
import { Button } from '../components/shared/Button';
import { featuredPost, gridPosts } from '../data/blog-posts';

const categories = [
  { id: 'all', label: 'All', count: 42, active: true },
  { id: 'intimacy', label: 'Intimacy', count: 12 },
  { id: 'playbook', label: 'Playbook', count: 8 },
  { id: 'research', label: 'Research', count: 6 },
  { id: 'long-distance', label: 'Long Distance', count: 5 },
  { id: 'design-notes', label: 'Design Notes', count: 4 },
];

export function BlogIndex() {
  useSEO({
    title: 'The Journal — Relationship Advice & Intimacy Tips',
    description: 'Essays, research, and playbooks for couples who want to go deeper. Expert advice on intimacy, communication, and connection.',
    keywords: 'relationship blog, intimacy tips, couple advice, relationship research',
  });

  return (
    <>
      {/* Hero */}
      <SectionWrapper className={styles.hero}>
        <div className={styles.heroContent}>
          <Chip>The Journal</Chip>
          <h1 className={`display ${styles.h1}`}>
            Words on love,<br />written for <ScriptText rotate={-2}>two.</ScriptText>
          </h1>
          <p className={styles.heroSub}>
            Essays, research, and playbooks for couples who want to go deeper.
          </p>
        </div>
      </SectionWrapper>

      {/* Categories */}
      <SectionWrapper className={styles.catSection}>
        <div className={styles.catRow}>
          {categories.map((c) => (
            <button
              key={c.id}
              className={`${styles.catPill} ${c.active ? styles.catActive : ''}`}
            >
              {c.label} <span className={styles.catCount}>{c.count}</span>
            </button>
          ))}
        </div>
      </SectionWrapper>

      {/* Featured Post */}
      <SectionWrapper>
        <Link to={`/blog/${featuredPost.slug}`} className={styles.featured}>
          <div className={styles.featuredImage} style={{ background: `linear-gradient(135deg, ${featuredPost.hue}22, var(--bg))` }}>
            <span className={styles.featuredHeart} style={{ color: featuredPost.hue }}>♥</span>
            <span className={styles.featuredLabel}>FEATURED</span>
          </div>
          <div className={styles.featuredContent}>
            <span className={styles.kicker}>{featuredPost.kicker}</span>
            <h2 className={styles.featuredTitle}>{featuredPost.title}</h2>
            <p className={styles.featuredExcerpt}>{featuredPost.excerpt}</p>
            <div className={styles.authorRow}>
              <div className={styles.authorAvatar} />
              <div>
                <span className={styles.authorName}>{featuredPost.author}</span>
                <span className={styles.authorMeta}>{featuredPost.date} · {featuredPost.readTime}</span>
              </div>
            </div>
            <Button variant="ghost">Read the essay →</Button>
          </div>
        </Link>
      </SectionWrapper>

      {/* Post Grid */}
      <SectionWrapper>
        <div className={styles.postGrid}>
          {gridPosts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className={styles.postCard}>
              <div className={styles.postImage} style={{ background: `linear-gradient(135deg, ${p.hue}22, var(--bg))` }}>
                <span className={styles.postKicker}>{p.kicker}</span>
                <span className={styles.postEmoji}>{p.emoji}</span>
              </div>
              <div className={styles.postContent}>
                <h3 className={styles.postTitle}>{p.title}</h3>
                <p className={styles.postExcerpt}>{p.excerpt}</p>
                <div className={styles.postMeta}>
                  <span>{p.author}</span>
                  <span>{p.date} · {p.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </SectionWrapper>

      {/* Newsletter */}
      <SectionWrapper className={styles.newsletter}>
        <h2 className={`display ${styles.nlTitle}`}>
          Get our weekly <ScriptText rotate={-2}>love letter.</ScriptText>
        </h2>
        <p className={styles.nlSub}>One essay a week. No spam. Easy to leave.</p>
        <form className={styles.nlForm} onSubmit={(e) => e.preventDefault()}>
          <input type="email" placeholder="your@email.com" className={styles.nlInput} />
          <Button variant="primary" type="submit">Subscribe</Button>
        </form>
      </SectionWrapper>
    </>
  );
}
